import ScrollableContainer from "./ScrollableContainer";
import Image from "next/image";
import { cx } from "classix";

type Props = {
  className?: string;
  width: number;
  height: number;
  alt: string;
  src: string;
};

export default function ScrollableImage({
  className,
  width,
  height,
  alt,
  src,
}: Props) {
  return (
    <ScrollableContainer className={cx("w-full overflow-x-scroll", className)}>
      <div className="mx-auto h-[200px] w-[1266px]">
        <Image src={src} alt={alt} width={width} height={height} />
      </div>
    </ScrollableContainer>
  );
}
